

if(annyang && $('body').hasClass('is-search') && window.SpeechKITT) {
  // Tell KITT to use annyang
        annyang.setLanguage('fr-FR');
        SpeechKITT.annyang();
        SpeechKITT.setInstructionsText('');

        // Define a stylesheet for KITT to use
        // SpeechKITT.setStylesheet('//cdnjs.cloudflare.com/ajax/libs/SpeechKITT/0.3.0/themes/flat.css');
        // Render KITT's interface
        SpeechKITT.displayRecognizedSentence(false);
        SpeechKITT.vroom();

        // var desktopAppend = false;
        // var mobileAppend = false;
        var letCloneSkitt = $("#skitt-ui").clone(true);
        // $("#skitt-ui").remove();
        $('#skitt-ui').find('#skitt-toggle-button').addClass('shadow');
        $('#skitt-ui').appendTo('#vocal');
        $('body').remove("#skitt-ui");

        // getCorrectAppendForSkitt();

        // $(window).resize(function() {
        //         getCorrectAppendForSkitt();
        // })

        // geoloc
        var coordinate;
        if(localStorage.getItem('geoloc_user')) {
                coordinate = localStorage.getItem('geoloc_user');
        } else {
                navigator.geolocation.getCurrentPosition(function (data) {
                        coordinate = data.coords.latitude+','+data.coords.longitude;
                        localStorage.setItem('geoloc_user', coordinate)
                });
        }
        if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (Position) {
                        var uri = "/ajax/bot?localisation="+coordinate;
                        $.ajax({
                                type:'GET',
                                url: uri,
                                dataType: 'json'
                        });

                });
        }      
}

